import axiosInstance from "@/api/axios";
import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import toastService from "@/services/toastService";
import { UserDetails } from "../user-profile/services/userProfileServices";
interface UserDetailsState {
  userDetails: UserDetails | null;
  loading: boolean;
  error: string | null;
  country: string | null;
  // loginDialog?: boolean; // if needed later
}

// Initial state
const initialState: UserDetailsState = {
  userDetails: null,
  loading: false,
  error: null,
  country: null,
};

// ✅ Async thunk to fetch user details (GET call)
export const fetchUserDetails = createAsyncThunk(
  "user/fetchDetails",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosInstance({
        method: "GET",
        url: "/user/api/v1/user/getUserDetailsForProfile",
      });
      toastService.success("User details fetched successfully");
      return response.data.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || "Fetching failed");
    }
  }
);

// Slice
const userDetailsSlice = createSlice({
  name: "userDetails",
  initialState,
  reducers: {
 setUserDetailsProfile: (state, action: PayloadAction<UserDetails>) => {
      state.userDetails = action.payload;
    },
  changeCountry: (state, action: PayloadAction<string>) => {
      state.country = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchUserDetails.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchUserDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.userDetails = action.payload;
      })
      .addCase(fetchUserDetails.rejected, (state, action) => {
        state.loading = false;
        console.log(action,"action")
        // state.error = action.payload || "Something went wrong";
      });
  },
});

// Export actions and reducer
export const {
  setUserDetailsProfile,
  changeCountry,
} = userDetailsSlice.actions;

export default userDetailsSlice.reducer;
